<template>
  <nav class="navbar is-shadowless is-transparent is-fixed-bottom" role="navigation" aria-label="main navigation">
    <div class="navbar-menu is-active">
      <div class="navbar-start pl-4">
        <!-- navbar items -->
        <button class="button" @click="goBack"><img src="@/assets/img/Cross_2.png" style="height: 14px;"></button>
      </div>
    </div>
  </nav>
</template>

<script>
import config from '@/config.js'
import firebase from 'firebase'
export default {

  name: 'NavBar',

  data () {
    return {
      episodes: config.episodes
    }
  },
  computed: {
    episode () {
      if (!this.$route.params.episode) {
        return '1'
      } else if (this.$route.params.episode > this.$root.progress.episode && !this.$root.progress.debug && !this.$root.progress.finished) {
        if (this.$root.progress.episode === 0) {
          return 'load'
        }
        return this.$root.progress.episode.toString()
      } else {
        return this.$route.params.episode
      }
    },
    chapter () {
      if (!this.$route.params.chapter) {
        return '1'
      } else if (this.$route.params.chapter > this.$root.progress.chapter && !this.$root.progress.debug && !this.$root.progress.finished && parseInt(this.episode) === this.$root.progress.episode) {
        if (this.$root.progress.chapter === 0) {
          return 'load'
        }
        return this.$root.progress.chapter.toString()
      } else {
        return this.$route.params.chapter
      }
    },
    currentChapter () {
      return this.episodes[this.$route.params.episode].chapters[this.$route.params.chapter]
    },
    storiesRead () {
      return this.$root.progress.number_of_stories
    },
    completed () {
      if (this.storiesRead.length >= this.currentChapter.storyCount) {
        return true
      }
      return false
    },
    episodeEnd () {
      var nextCp = parseInt(this.$route.params.chapter) + 1
      if (nextCp > this.episodes[this.$route.params.episode].chapterCount) {
        return true
      }
      return false
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    nextChapter () {
      var progRef = firebase.database().ref('/users/' + firebase.auth().currentUser.uid + '/progress')
      var nextEp = parseInt(this.episode)
      var nextCp = parseInt(this.chapter) + 1
      if (this.episodeEnd) {
        nextEp++
        nextCp = 1
        progRef.update({ episodeEnded: Date.parse(new Date()) })
      }
      var forwardProgress = () => {
        if (this.$root.progress.debug) {
          return false
        }
        if (this.$root.progress.finished) {
          return true
        } else if (nextCp > this.$root.progress.chapter && nextEp >= this.$root.progress.episode) {
          return true
        } else if (nextEp > this.$root.progress.episode) {
          return true
        }
        return false
      }
      if (forwardProgress()) {
        progRef.update({ episode: nextEp, chapter: nextCp, number_of_stories: 0 })
      } else {
        progRef.update({ number_of_stories: 0 })
      }
      this.$router.replace('/location/' + nextEp + '/' + nextCp)
    }
  }
}
</script>

<style lang="css" scoped>

</style>
